import { faArrowDown, faArrowRightArrowLeft, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import cn from 'classnames';
import { formatDateTimeUA } from 'helpers/formatDate';
import { TRANSACTION_TYPES } from 'constants/transactionTypes';
import { MoneyAmount } from 'components/MoneyAmount';
import styles from './TransactionCard.scss';

const ICON_MAP = {
  [TRANSACTION_TYPES.INCOME]: faArrowDown,
  [TRANSACTION_TYPES.EXPENSE]: faArrowUp,
  [TRANSACTION_TYPES.TRANSFER_IN]: faArrowRightArrowLeft,
  [TRANSACTION_TYPES.TRANSFER_OUT]: faArrowRightArrowLeft,
};

const TYPE_CLASSES = {
  [TRANSACTION_TYPES.INCOME]: [styles.income],
  [TRANSACTION_TYPES.EXPENSE]: [styles.expense],
  [TRANSACTION_TYPES.TRANSFER_IN]: [styles.transfer, styles.income],
  [TRANSACTION_TYPES.TRANSFER_OUT]: [styles.transfer, styles.expense],
};

const AMOUNT_SIGN = {
  [TRANSACTION_TYPES.EXPENSE]: -1,
  [TRANSACTION_TYPES.TRANSFER_OUT]: -1,
};

export const TransactionCard = ({ transaction }) => {
  const { type, description, createdAt, operator, amount, locationID } = transaction;
  const { locations } = useSelector((state) => state.locations);

  const locationName = useMemo(() => locations.find((l) => l.id === locationID)?.name, [locations, locationID]);

  return (
    <div className={cn(styles.item, TYPE_CLASSES[type])}>
      <div className={styles.icon}>
        <FontAwesomeIcon icon={ICON_MAP[type]} />
      </div>

      <div className={styles.details}>
        <div className={styles.description}>{description}</div>
        <div className={styles.meta}>
          <span className={styles.time}>{formatDateTimeUA(createdAt, true)}</span>
          {locationName && <span className={styles.location}>• {locationName}</span>}
          <span className={styles.operator}>
            • {operator.surname} {operator.name[0]}.
          </span>
        </div>
      </div>

      <div className={styles.amount}>
        <MoneyAmount value={(AMOUNT_SIGN[type] ?? 1) * amount} className={styles.value} />
      </div>
    </div>
  );
};
